import { enumFacilityGroupSortOption } from '@rematter/frontend-lib-api-client';

import { createEntitySelect } from './helpers/createEntitySelect';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const facilityGroupsQueryAtom = createQueryAtomFactory(
  'shared.selectFacilityGroup',
  () => ({
    facilityGroups: {
      __args: {
        sorting: [enumFacilityGroupSortOption.NameAsc],
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data) => data?.facilityGroups.entries ?? [],
  },
);

export const SelectFacilityGroup = createEntitySelect(
  'SelectFacilityGroup',
  facilityGroupsQueryAtom,
  {
    formatLabel: (entity) => entity.name,
  },
);
